<h1 mat-dialog-title class="title">{{ data.title }}</h1>
<div mat-dialog-content class="description">
  <p class="description__text">{{ data.description }}</p>
</div>
<div mat-dialog-options class="input">
  <mat-radio-group class="options" [(ngModel)]="selected">
    <mat-radio-button [value]="option.action" *ngFor="let option of data.options">
      <div class="input-label">
        <span [innerHTML]="option.text"></span>
      </div>
    </mat-radio-button>
  </mat-radio-group>
</div>
<div class="actions">
  <button class="actions__button" mat-stroked-button color="primary" [disabled]="!selected" (click)="confirm()">
    <span> {{ 'FC_CHOICE_DIALOG.CONFIRM' | translate }} </span>
  </button>

  <button class="actions__button" mat-flat-button color="primary" (click)="close()">
    <span> {{ 'FC_CHOICE_DIALOG.CANCEL' | translate }} </span>
  </button>
</div>
